/* eslint-disable */
/* tslint-disable */
// @ts-nocheck
import { fetchRaw } from '../../utils/fetch'
import { Service, inject, service } from '../di'
import { ConfigService } from '../ConfigService'
import detectUserEnv from '../../utils/detectUserEnv'
import * as CommonAnalytics from './CommonAnalyticsBeacons'
import * as BrowseAnalytics from './BrowseAnalyticsBeacons'

import { LocationService } from '../LocationService'

export const userEnv: {
    browser: string
    version: string
    mobile: number
    os: string
    osversion: string
} = detectUserEnv()

export interface Options {
    [key: string]: any
}

@service('avroService')
export class AvroService extends Service {
    defaultString: string = 'FlippAvroDefault'
    testChannelIds: number[] = [3280, 3182, 3179, 3138, 3127]

    @inject config: ConfigService
    @inject location: LocationService

    public getBase(aid: CommonAnalytics.ApplicationID): CommonAnalytics.Base {
        return {
            aid,
            postalCode: { string: this.postalCode() },
            rnd: Math.random().toString(),
        }
    }

    public getClientParameters(): BrowseAnalytics.ClientParameters {
        return {
            browser: userEnv.browser || this.defaultString,
            browserVersion: userEnv.version || this.defaultString,
            system:
                userEnv.os || (userEnv.mobile ? 'mobile' : this.defaultString),
            systemModel: this.defaultString,
            systemVersion: userEnv.osversion || this.defaultString,
        }
    }

    public getEnvironment(): BrowseAnalytics.Environment {
        const channelId = Number(this.config.channelId)

        switch (this.config.ENV) {
            case 'development':
                return BrowseAnalytics.Environment.Dev
            case 'production':
                // workaround for our production native-modules that hosted on staging s3 bucket http://s3.amazonaws.com/flipp-module/test-module3.0.html
                if (this.testChannelIds.includes(channelId))
                    return BrowseAnalytics.Environment.Test

                return BrowseAnalytics.Environment.Prod
            case 'staging':
                return BrowseAnalytics.Environment.Test
            default:
                return BrowseAnalytics.Environment.Dev
        }
    }

    public getLocationSource(): BrowseAnalytics.LocationSource {
        return BrowseAnalytics.LocationSource.Default
    }

    public async FireAvroBeacon(data: any) {
        if (!(await this.location.isAllowedCountry())) return

        fetchRaw(this.config.AVRO_BEACONS, {
            method: 'POST',
            headers: [['Content-Type', 'text/plain; charset=UTF-8']],
            body: encodeURI(JSON.stringify([data])),
        })
    }

    // duplicated this method from locationService, coz cannot inject it and cannot getInstance of it in this class
    private postalCode() {
        return document.documentElement.getAttribute('postalcode')
    }
}
